import useMediaQuery, { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { ACCOUNT_SELECTION_URL, CART_PAGE, CUSTOMER_REGISTER_PAGE } from "~/utils/url/staticUrls";
import { isForkPage } from "~/utils/url/urlUtils";

export function useIsBottomNavigationVisible() {
  const isMinTablet = useIsMinTabletSize();

  const isPrint = !useMediaQuery("only screen");
  const isCartPage = window.location.pathname.endsWith(CART_PAGE);
  const isAccountSelectPage = window.location.pathname.endsWith(ACCOUNT_SELECTION_URL);
  const isSelfRegistrationPage = window.location.pathname.endsWith(CUSTOMER_REGISTER_PAGE);

  if (isMinTablet || isPrint || isCartPage || isForkPage() || isAccountSelectPage || isSelfRegistrationPage) {
    return false;
  }

  return true;
}
